import { render, staticRenderFns } from "./Preparation.vue?vue&type=template&id=1c5fead2&scoped=true"
import script from "./Preparation.vue?vue&type=script&lang=ts"
export * from "./Preparation.vue?vue&type=script&lang=ts"
import style0 from "./Preparation.vue?vue&type=style&index=0&id=1c5fead2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5fead2",
  null
  
)

export default component.exports